import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import SalesOverview from "../Pages/SalesOverview";
import Company from "../Pages/Company";
import Header from "../Pages/LandingPage/Header";
import CreateNewAccount from "../Pages/SalesOverview/CreateNewAccount";
import ReviewAccount from "../Pages/SalesOverview/ReviewAccount";
import EditAccount from "../Pages/SalesOverview/EditAccount";
import AddCompany from "../Pages/Company/AddCompany";
import ReviewCompany from "../Pages/Company/ReviewCompany";
import EditCompany from "../Pages/Company/EditCompany";
import Login from "../Pages/LandingPage/Login";
import NotFound from "../Pages/NotFound";

const Routing = () => {
  useEffect(() => {
    // Scroll to the top whenever the component renders or updates
    window.scrollTo(0, 0);
  }, []); // Add dependencies here if needed
  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    return token ? children : <Navigate to="/" replace />;
  };

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Header />
          </ProtectedRoute>
        }
      >
        <Route path="/sales-overview" element={<SalesOverview />} />
        <Route path="/company" element={<Company />} />
        <Route path="/create-account" element={<CreateNewAccount />} />
        <Route path="/review-account/:id" element={<ReviewAccount />} />
        <Route path="/edit-account/:id" element={<EditAccount />} />
        <Route path="/create-company" element={<AddCompany />} />
        <Route path="/review-company/:id" element={<ReviewCompany />} />
        <Route path="/edit-company/:id" element={<EditCompany />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routing;
